import { PaginationParams, SearchingProps } from 'modules/Shared/type';
import Media from 'modules/Media/model/Media';
import MediaAdvancement from 'modules/Media/model/MediaAdvancement';

export interface MediaListState extends SearchingProps {
  media: Media[];
  mediaAdvancement: MediaAdvancement[];
  fetching: boolean;
  totalPages: number;
  pagination: PaginationParams;
}

export const initMediaListState = (): MediaListState => ({
  media: [],
  mediaAdvancement: [],
  pagination: {
    page: 1,
    count: 100
  },
  totalPages: 1,
  filter: {},
  sort: {},
  fetching: false
});
